const ayats = [
  '«Аллах силердин араңардагы ыймандуулардын жана илим берилгендердин даражасын көтөрөт.»',
  '«Чындыгында, пенделеримдин билимдүүлөрү Аллахтан коркушат. Ырасында, Аллах-Ызааттуу, Кечиримдүү.»',
  '«Биз (Курандагы) мисалдарды адамдарга түшүндүрүш үчүн баяндайбыз, жана ал мисалдарды илимдүүлөр гана түшүнүшө алат»',
  '«Эй (Мухаммад!) Аларга: “Билгендер менен билбегендер тең боло албайт?”-деп айт. Чындыгында акыл ээлери гана (Курандын) насаат алат» (Зумар 39:9)',
];

export default ayats;
